// NPM Imports
import React, { Fragment } from "react";
import PropTypes, { object } from "prop-types";
import { Button } from "@revvsales/components";
import SIGNUP_STEPS from "../../../../assets/signup_steps.png";

// CSS Imports
import orgCreationForm from "./orgcreationform.module.scss";

// Internals Imports
import { AUTH } from "../../../../constants";

// Destructuring
const { PASSWORD_BASED_AUTH } = AUTH;

const OrgCreationForm = props => {
  const {
    // allowUserToJoin,
    email,
    errMessage,
    fname,
    handleOrgCreationForm,
    inputChangeHandler,
    isInviteSignup,
    lname,
    orgName,
    password,
    signupMethod,
    suggestion,
  } = props;
  return (
    <Fragment>
      <div className={orgCreationForm.flowImage}>
        <img src={SIGNUP_STEPS} alt="Revv Signup flow" />
      </div>
      {errMessage}
      <div className={`formRow ${orgCreationForm.row}`}>
        <div className={`formCol ${orgCreationForm.fieldContainer}`}>
          <span className={`formLabel ${orgCreationForm.fieldLabel}`}>
            First name
            <span
              className={`formRequiredIcon ${orgCreationForm.requiredInput}`}>
              *
            </span>
          </span>
          <input
            data-test="orgcreationform-first-name"
            className={`formControl ${orgCreationForm.formControl}`}
            type="text"
            placeholder="Enter your first name"
            name="fname"
            value={fname}
            onChange={inputChangeHandler}
            onKeyPress={event => {
              if (event.key === "Enter") {
                handleOrgCreationForm();
              }
            }}
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus
          />
        </div>
        <div className={`formCol ${orgCreationForm.fieldContainer}`}>
          <span className={`formLabel ${orgCreationForm.fieldLabel}`}>
            Last name
            <span
              className={`formRequiredIcon ${orgCreationForm.requiredInput}`}>
              *
            </span>
          </span>
          <input
            data-test="orgcreationform-last-name"
            className={`formControl ${orgCreationForm.formControl}`}
            type="text"
            placeholder="Enter your last name"
            name="lname"
            value={lname}
            onChange={inputChangeHandler}
            onKeyPress={event => {
              if (event.key === "Enter") {
                handleOrgCreationForm();
              }
            }}
          />
        </div>
      </div>

      {isInviteSignup && (
        <div className={`formRow ${orgCreationForm.row}`}>
          <div className={`formCol ${orgCreationForm.fieldContainer}`}>
            <span className={`formLabel ${orgCreationForm.fieldLabel}`}>
              Work Email
            </span>
            <div className="trailsignup-domainname-wrapper">
              <input
                data-test="orgcreationform-work-email"
                className="formControl"
                type="email"
                placeholder="Enter your work email"
                name="email"
                value={email}
                disabled
                onKeyPress={event => {
                  if (event.key === "Enter") {
                    handleOrgCreationForm();
                  }
                }}
              />
            </div>
          </div>
        </div>
      )}
      {!isInviteSignup && suggestion && !suggestion.name && (
        <div
          className={`formRow ${orgCreationForm.row}`}
          data-test="orgcreationform-org-name">
          <div className={`formCol ${orgCreationForm.fieldContainer}`}>
            <span className={`formLabel ${orgCreationForm.fieldLabel}`}>
              Organization name{" "}
              <span
                className={`formRequiredIcon ${orgCreationForm.requiredInput}`}>
                *
              </span>
            </span>
            <div className={orgCreationForm.trailSignupDomainnameWrapper}>
              <input
                className={`formControl ${orgCreationForm.formControl}`}
                type="text"
                placeholder="Enter your organization’s name."
                name="orgName"
                value={orgName}
                disabled={suggestion && suggestion.name}
                onChange={inputChangeHandler}
                onKeyPress={event => {
                  if (event.key === "Enter") {
                    handleOrgCreationForm();
                  }
                }}
              />
            </div>
          </div>
        </div>
      )}
      {signupMethod === PASSWORD_BASED_AUTH && (
        <div
          className={`formRow ${orgCreationForm.row}`}
          data-test="orgcreationform-password">
          <div className={`formCol ${orgCreationForm.fieldContainer}`}>
            <span className={`formLabel ${orgCreationForm.fieldLabel}`}>
              Password
              <span
                className={`formRequiredIcon ${orgCreationForm.requiredInput}`}>
                *
              </span>
            </span>
            <div>
              <input
                className={`formControl ${orgCreationForm.formControl}`}
                type="password"
                placeholder="Enter your password (Minimum 6 characters)"
                name="password"
                value={password}
                onChange={inputChangeHandler}
                onKeyPress={event => {
                  if (event.key === "Enter") {
                    handleOrgCreationForm();
                  }
                }}
              />
            </div>
          </div>
        </div>
      )}

      <div className={`revvModalFooter ${orgCreationForm.popupFooter}`}>
        <div>
          <Button
            data-test="orgcreationform-get-started"
            type="submit"
            className={orgCreationForm.btn}
            onClick={handleOrgCreationForm}>
            Let’s get started
          </Button>
        </div>
      </div>
    </Fragment>
  );
};

OrgCreationForm.defaultProps = {
  errMessage: null,
  fname: "",
  lname: "",
  orgName: "",
  password: "",
  isInviteSignup: undefined,
  suggestion: object,
};

OrgCreationForm.propTypes = {
  errMessage: PropTypes.string,
  email: PropTypes.string.isRequired,
  fname: PropTypes.string,
  lname: PropTypes.string,
  orgName: PropTypes.string,
  password: PropTypes.string,
  isInviteSignup: PropTypes.bool,
  signupMethod: PropTypes.string.isRequired,
  inputChangeHandler: PropTypes.func.isRequired,
  handleOrgCreationForm: PropTypes.func.isRequired,
  suggestion: PropTypes.shape({
    fjoin: PropTypes.bool,
    name: PropTypes.string,
    pe_domain: PropTypes.bool,
    sub_domain: PropTypes.string,
  }),
};

export default OrgCreationForm;
